// Prominent header for Course / Practice / Event / Group detail pages: the cover color (or the
// default brand gradient) as a banner, a large icon tile and the title —
// in the spirit of the course cover banner and the practice hero.
import { Avatar } from './ui';
import { cssBackground } from './ColorField';
import { textOn } from '../lib/color';

// iconColor (V66): the tile's own color; without it the tile stays a light
// see-through square on the cover color, as before.
export default function ProgramHero({ kind, name, iconSrc, coverColor, iconColor, sub }) {
  const bg = coverColor ? cssBackground(coverColor) : 'linear-gradient(135deg, var(--wpl-500, #6366f1), var(--wpl-700, #4338ca))';
  // Light cover → dark text (white is unreadable on it).
  const t = textOn(coverColor ? bg : '#4338ca');
  return (
    <div style={{
      background: bg, borderRadius: 12, padding: '20px 22px', marginBottom: 14,
      display: 'flex', alignItems: 'center', gap: 18, color: t.color,
    }}>
      <div style={{
        borderRadius: 16, border: '3px solid rgba(255,255,255,0.75)', boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        overflow: 'hidden', flexShrink: 0, lineHeight: 0,
      }}>
        <Avatar name={name} src={iconSrc} square size={96}
          bg={iconColor ? cssBackground(iconColor) : (coverColor ? 'rgba(255,255,255,0.18)' : undefined)} />
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: '0.6875rem', textTransform: 'uppercase', letterSpacing: 1, opacity: 0.9, fontWeight: 600 }}>{kind}</div>
        <div style={{ fontSize: '1.6rem', fontWeight: 800, lineHeight: 1.2, textShadow: t.shadow, overflowWrap: 'anywhere' }}>{name}</div>
        {sub && <div style={{ opacity: 0.95, fontSize: '0.875rem', marginTop: 4, color: t.sub, textShadow: t.shadow === 'none' ? 'none' : '0 1px 4px rgba(0,0,0,0.3)' }}>{sub}</div>}
      </div>
    </div>
  );
}
